// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"4976":"c16184b3","5219":"d332e505"}[chunkId] || chunkId) + "." + {"4976":"32943bab1d386262","5219":"ab79ed12412562bd","8109":"1c8093d046557b92","8568":"9fac82b7bf87a244"}[chunkId] + ".js";
};